// removed by extract-text-webpack-plugin
module.exports = {"body":"kOIl"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Blog/BlogFilterModal/BlogFilterModal.scss
// module id = jAVB
// module chunks = 0